export const compareArrays = (arrayA: string[], arrayB: string[]) => {
  const sortedArrayA = arrayA.sort();
  const sortedArrayB = arrayB.sort();
  return JSON.stringify(sortedArrayA) === JSON.stringify(sortedArrayB);
};
